import { render } from "./TemplateCopyModal.vue?vue&type=template&id=cb4099b8&scoped=true"
import script from "./TemplateCopyModal.vue?vue&type=script&lang=js"
export * from "./TemplateCopyModal.vue?vue&type=script&lang=js"

import "./TemplateCopyModal.vue?vue&type=style&index=0&id=cb4099b8&scoped=true&lang=css"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4099b8"]])

export default __exports__